import { pushEvent } from '../../client/data-layer';
import { ProductCollectionSortOption } from '../../types';

/**
 * Tracks when a product collection facet navigation is performed
 * @param filter Current filter
 * @param property Name of next available facet
 * @param value Clicked facet value
 */
export const trackProductCollectionFacetNavigation = (
  filter: any,
  property: string,
  value: string
) => {
  pushEvent('productCollectionFacetNavigation', {
    filter,
    property,
    value,
  });
};

/**
 * Tracks when the sorting of a product collection changes.
 * @param sort New sort mode
 */
export const trackProductCollectionSortUpdate = (
  sort: ProductCollectionSortOption
) => {
  pushEvent('productCollectionSortUpdate', { sort });
};

/**
 * Tracks when the filter of a product collection is cleared.
 * @param filter Current filter
 * @param property Cleared property, empty string on "clear all"
 */
export const trackProductCollectionFilterClear = (
  filter: any,
  property: string = ''
) => {
  pushEvent('productCollectionFilterClear', { filter, property });
};

/**
 * Tracks when the filter of a product collection is updated.
 * @param filter Current filter
 * @param property Updated property
 * @param value New value
 */
export const trackProductCollectionFilterUpdate = (
  filter: any,
  property: string,
  value: string
) => {
  pushEvent('productCollectionFilterUpdate', {
    filter,
    property,
    value,
  });
};

/**
 * Tracks when a product collection quick filter panel is opened.
 * @param property Quick filter property
 */
export const trackProductCollectionQuickFilterOpen = (property: string) => {
  pushEvent('productCollectionQuickFilterOpen', {
    property,
  });
};

/**
 * Tracks when a product in a product collection is clicked.
 * @param productId ID of product clicked
 */
export const trackProductCollectionProductClick = (
  productId: string | number
) => {
  pushEvent('productCollectionProductClick', { productId });
};

/**
 * Tracks when product collection pagination is clicked
 * @param current Current page
 * @param page Clicked page
 * @param pageType Clicked page type
 */
export const trackProductCollectionPagination = (
  current: number,
  page: number,
  pageType: string
) => {
  pushEvent('productCollectionPagination', { current, page, pageType });
};
